import { FEATURE_ITEMS } from '../../constants';

type FeatureIconType = (typeof FEATURE_ITEMS)[number]['icon'];

type FeatureItem = {
  id: string;
  icon: FeatureIconType;
  title: string;
  description: string;
  descriptionBold: string;
};

interface FeaturesListProps {
  items?: readonly FeatureItem[];
}

const iconPaths: Record<FeatureIconType, string> = {
  clock: '/images/icons/payment-page-v2/icon-clock.svg',
  pulse: '/images/icons/payment-page-v2/icon-pulse.svg',
  checkbox: '/images/icons/payment-page-v2/icon-checkbox.svg',
  document: '/images/icons/payment-page-v2/icon-document.svg',
  chart: '/images/icons/payment-page-v2/icon-chart.svg',
};

// Helper to render description with bold text
const renderDescription = (description: string) => {
  // Parse markdown-style bold (**text**)
  const parts = description.split(/\*\*(.*?)\*\*/);
  return parts.map((part, index) => {
    // Odd indices are the bold parts (content between **)
    if (index % 2 === 1) {
      return (
        <span key={index} className="font-semibold">
          {part}
        </span>
      );
    }
    return part;
  });
};

export const FeaturesList = ({ items = FEATURE_ITEMS }: FeaturesListProps) => {
  return (
    <div className="w-full">
      <h3 className="text-base font-semibold text-slate-900 leading-[1.3] mb-8">What&apos;s included in your free trial</h3>
      <div className="flex flex-col gap-4">
        {items.map((feature) => (
          <div key={feature.id} className="flex items-start gap-5">
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-catch-dark-blue-90 flex items-center justify-center">
              <img
                src={iconPaths[feature.icon]}
                alt=""
                className="w-5 h-5 [filter:brightness(0)_invert(1)]"
              />
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-base font-semibold text-slate-900">{feature.title}</span>
              <span className="text-base text-slate-500">{renderDescription(feature.description)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesList;
